// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1O0Y-","inner":"Form_inner__29mqh","range":"Form_range__1HAg7","name":"Form_name__268Kl","actions":"Form_actions__1FOM3"};